module.exports = __webpack_public_path__ + "img/addMerchantBtn.6f448aa6.png";